import { Component } from "react";

export default class TabErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="border border-red-500/40 bg-red-500/5 p-6 space-y-3" data-testid="tab-error">
        <div className="font-serif text-xl text-red-300">This section hit an error</div>
        <pre className="text-xs text-imi-text/70 whitespace-pre-wrap break-words">{String(this.state.error?.message || this.state.error)}</pre>
        <button type="button" onClick={() => window.location.reload()} className="text-[11px] uppercase tracking-[0.2em] border border-imi-gold/50 text-imi-gold px-4 py-2 hover:bg-imi-gold/10">
          Reload page
        </button>
      </div>
    );
  }
}
